.chart-tooltip-wrapper{color:#fff;border-radius:3px;background:#000000b3;transition:all .1s ease}
/*# sourceMappingURL=dashboard-chart-tooltip.component-MSVSFSYS.css.map */
